import React, { FunctionComponent } from 'react'
import { Animated, StyleSheet, Text, View, TextInput, Dimensions, Platform, useWindowDimensions } from 'react-native';
import MyText from './MyText';
// import Video from 'react-native-video';
import { Video } from 'expo-av';
//<Video source={require("./assets/intro.mp4")}
const Splash = (props) => {
    const {height, width} = useWindowDimensions();

    const [finished, setFinished] = React.useState(false);
    const [done, setDone] = React.useState(false);

    const fadeAnim = React.useRef(new Animated.Value(1)).current;

    const fadeIn = () => {
        Animated.timing(fadeAnim, {
            toValue: 0,
            duration: 500,
            useNativeDriver: true,
        }).start();
    };

    const fadeOut = () => {
        Animated.timing(fadeAnim, {
            toValue: -width-1,
            duration: 500,
            useNativeDriver: true,
        }).start();
    };

    React.useEffect(() => {
        if(props.done){
            setTimeout(() => {
                fadeOut();
                setTimeout(() => {
                    setDone(true);
                },600);
            },100);
        }
        else{
            fadeIn();
        }
    },[props.done]);

    return (
        <>
        {
            done?null:
            <Animated.View style={[styles.videoView, {transform: [{translateX: fadeAnim}]}]}>
                <Video 
                    // source={{uri: 'https://download.samplelib.com/mp4/sample-5s.mp4'}}   // Can be a URL or a local file.
                    // ref={(ref) => {
                    //     this.player = ref
                    // }}                                      // Store reference
                    // onBuffer={this.onBuffer}                // Callback when remote video is buffering
                    // onError={this.videoError}               // Callback when video cannot be loaded
                    // style={styles.videoStyle} 
                    // resizeMode={'contain'}
                    source={width>height?require("./assets/intro_landscape.mp4"):require("./assets/newIntro.mp4")}
                    rate={1.0}
                    resizeMode={'cover'}
                    shouldPlay={true}
                    isMuted={true}
                    onPlaybackStatusUpdate={(e) => {
                        if(e.positionMillis > 3500){
                            if(!finished){
                                setFinished(true);
                                props.finished();
                            }
                        }
                    }}
                    // isLooping
                    videoStyle={Platform.OS==='web'?styles.videoStyle:null}
                    style={styles.videoView}
                />
            </Animated.View>
        }
        </>
    )
}
const styles = StyleSheet.create({
    videoView: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: '#64348E',
        // flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    videoStyle: {
        width: '100%',
        height: '100%',
        resizeMode: 'cover'
        // position: 'relative'
    },
})
export default Splash